var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTrouble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "59px",
    viewBox: "0 0 52 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.18018102 32,16.0373832 C32,20.8685844 29.8687274,25.2008371 26.4971752,28.1410666 L16.0250448,39 L5.52692836,28.1620446 C2.1414336,25.221464 0,20.8800872 0,16.0373832 C0,7.18018102 7.163444,0 16,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.6765625,12.1125 L9.2140625,2.653125 C8.546875,1.496875 7.4546875,1.496875 6.7859375,2.653125 L1.325,12.1125 C0.65625,13.2703125 1.203125,14.2140625 2.5375,14.2140625 L13.4625,14.2140625 C14.796875,14.2140625 15.34375,13.2703125 14.6765625,12.1125 Z M8.6765625,12.125 C8.53125,12.2671875 8.3640625,12.353125 8.178125,12.3859375 C8.11875,12.3890625 8.0609375,12.390625 8,12.390625 C7.9390625,12.390625 7.88125,12.3890625 7.821875,12.3859375 C7.634375,12.353125 7.46875,12.265625 7.3234375,12.125 C7.134375,11.9390625 7.040625,11.7171875 7.040625,11.453125 C7.040625,11.1921875 7.134375,10.965625 7.3234375,10.7765625 C7.5125,10.5875 7.7390625,10.4921875 8,10.4921875 C8.2609375,10.4921875 8.4875,10.5875 8.6765625,10.7765625 C8.865625,10.965625 8.959375,11.1921875 8.959375,11.453125 C8.9609375,11.715625 8.8671875,11.940625 8.6765625,12.125 Z M8.459375,9.9171875 L7.5578125,9.9171875 C7.4484375,8.5828125 7.0421875,6.7484375 7.0421875,6.4984375 C7.0421875,6.2125 7.13125,5.971875 7.3109375,5.778125 C7.4921875,5.5828125 7.7203125,5.484375 8.0015625,5.484375 C8.28125,5.484375 8.5109375,5.58125 8.6921875,5.7734375 C8.871875,5.9671875 8.9609375,6.2078125 8.9609375,6.4984375 C8.9609375,6.7484375 8.5859375,8.5828125 8.459375,9.9171875 L8.459375,9.9171875 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-25.1%",
    y: "-20.1%",
    width: "150.3%",
    height: "156.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 11,
    transform: "translate(-646.000000, -564.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(656.000000, 570.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408\\u5907\\u4EFD-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F25643",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u611F\\u53F9\\u53F7",
    transform: "translate(8.000000, 7.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrouble);
export default __webpack_public_path__ + "static/media/icon_trouble.a0f27527887d6392f51438b635a82b10.svg";
export { ForwardRef as ReactComponent };